import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import MetaDecorators from '../components/MetaDecorators';
import SingleVideoCards from '../components/SingleVideoCards';
import VideosCards from '../components/VideosCards';
import { getTestimonialSectionService } from '../services/apiServices';

function VideosViewAllLanding() {
  const { domainDetails } = useSelector((state) => state.listings);
  const [sectionsData, setSectionsData] = useState([]);
  const { orgId, sectionId, sectionName } = useParams();

  const history = useHistory();

  useEffect(() => {
    if (orgId && sectionId && domainDetails && domainDetails.orgType !== 'certifier') {
      fetchTestimonial(orgId, sectionId);
    } else {
      history.push('/');
    }
  }, [domainDetails, orgId, sectionId]);

  const fetchTestimonial = (orgId, sectionId) => {
    getTestimonialSectionService(orgId, sectionId)
      .then((response) => setSectionsData(response.testimonials))
      .catch((error) => console.log(error));
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <div className='videosSectionWrapper'>
      <MetaDecorators />
      <div className='videosSectionHeading'>{sectionsData.length === 1 ? null : <h1>{capitalizeFirstLetter(sectionName)}</h1>}</div>
      <div className='videosCardsWrapper'>
        {sectionsData.map((items, index) => {
          if (!isMobile && sectionsData.length === 1) {
            return <SingleVideoCards items={items} sectionName={capitalizeFirstLetter(sectionName)} />;
          } else {
            return <VideosCards key={index} items={items} sectionName={capitalizeFirstLetter(sectionName)} />;
          }
        })}
      </div>
    </div>
  );
}

export default VideosViewAllLanding;
